/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unknown-property */
import React, {
    useState, useEffect, useCallback, useContext,
} from 'react';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { distributorService } from '../../../service/distributor.service';
import CategoryListSkeleton from './categorylistSkeleton';
import AddCategoryModal from './Modals/AddCategoryModal';
import Pagination from '../../../Components/Pagination';
import EmptyScreen from '../../../Components/GlobalEmplyPage';

function CategoryManagement() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [addCategoryPopup, setAddcategoryPopup] = useState(false);
    const [searchValue, setsearchValue] = useState('');
    const [categoryList, setCategoryList] = useState([]);
    const [addCategoryDetails, setaddCategoryDetails] = useState({
        name: '',
        description: '',
    });
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [submitSelected, setsubmitSelected] = useState(false);
    const [errorState, setErrorState] = useState({
        name: '',
        description: '',
    });
    const [threeDotLoader, setThreeDotsLoader] = useState(false);
    const [editAction, setEditAction] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [selected, setSelected] = useState({});
    const [emptyData, setEmptyData] = useState(false);

    const handleFetch = useCallback((() => {
        distributorService.CreateCategoryList(currentPage, searchValue).then((res) => {
            if (!res.error && res.data.data.success_status) {
                if (res.data.data.Items.length > 0) {
                    setEmptyData(false);
                } else {
                    setEmptyData(true);
                }
                setCategoryList(res.data.data.Items);
                setCurrentPage(res.data.data.current_page);
                setTotalPage(res.data.data.number_of_pages);
                setalldata(res.data.data);
                setLoading(false);
            } else {
                // handleErrorMessage(details?.data.message);
                // setloading(false);
            }
        });
    }), [currentPage, searchValue]);

    const handlePageClick = async (data) => {
        setLoading(true);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const validate = () => {
        setsubmitSelected(true);
        let isvalid = true;
        Object.keys(addCategoryDetails).forEach((value) => {
            switch (value) {
            case 'name':
            case 'description':
                if (addCategoryDetails[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };

    const handleUpdate = (category) => {
        setSelected(category);
        setIsEdit(true);
        setAddcategoryPopup(true);
    };

    const handleClose = () => {
        setsubmitSelected(false);
        setaddCategoryDetails({
            name: '',
            description: '',
        });
    };

    const createResoureCategory = async (e) => {
        if (validate()) {
            setThreeDotsLoader(true);
            setsubmitSelected(false);
            const payload = {
                name: addCategoryDetails.name,
                description: addCategoryDetails.description,
            };
            let res;
            if (isEdit) {
                res = await distributorService.UpdateCategory(payload, selected.resource_category_id);
            } else {
                res = await distributorService.CreateCategory(payload);
            }
            if (!res.error && res.data.success_status) {
                setEditAction('');
                setAddcategoryPopup(false);
                setThreeDotsLoader(false);
                setIsEdit(false);
                setLoading(true);
                SetSuccessMessage(res.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
                setSelected('');
                setaddCategoryDetails((prevState) => ({
                    ...prevState,
                    name: '',
                    description: '',
                }));
                handleFetch();
                setsubmitSelected(false);
            } else {
                SetErrorMessage(res.data.message);
            }
            setErrorState({
                name: '',
                description: '',
            });
        }
    };

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    return (
        <div className="pb-6 pr-[18px] main-screen">
            <div className="w-full flex justify-between items-center pt-6 pb-[18px] sticky top-[0]">
                <div>
                    <h5 className="text-xs4 font-normal text-[#555259]">Category Management</h5>
                </div>
                <div className="flex justify-end items-center">
                    <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                        <input
                            type="text"
                            className="w-[180px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0"
                            placeholder="Search"
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                                if (e.target.value !== '') {
                                    setCurrentPage(1);
                                }
                            }}
                        />
                        <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1" />
                    </div>
                    <button
                        type="button"
                        className="ml-2.5 bg-[#555259] border-[#555259] font-semibold text-xs2 h-9 text-[#FFFFFF] border-2 py-1 px-7 rounded-[9px]"
                        data-bs-toggle="modal"
                        data-bs-target="#add-category"
                        onClick={() => setAddcategoryPopup(true)}
                    >
                        Add New
                    </button>
                </div>
            </div>
            {loading ? <CategoryListSkeleton /> : (
                <div>
                    { categoryList.length > 0 && (
                        <div
                            className="overflow-auto sidebar pb-7 relative z-10 h-customh4"
                            style={{ height: 'calc(100vh - 298px)' }}
                        >
                            <table className="w-full table-auto relative">
                                <thead class="sticky top-0 left-0 z-[2]">
                                    <tr class="bg-[#555259] h-10">
                                        <th scope="col" class="py-3 px-7  min-w-[152px] rounded-bl-lg rounded-tl-lg ">
                                            <span class="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                Name
                                                {/* <a href="#" class="pl-[5px]">
                                        <img src="images/sort.svg" alt="icon" />
                                    </a> */}
                                            </span>
                                        </th>
                                        <th class="py-3 px-6 min-w-[158px] bg-[#555259] text-left" scope="col">
                                            <span class="text-xs5 font-bold text-[#FFFFFF]">
                                                Description
                                            </span>
                                        </th>
                                        <th scope="col" class="py-3 px-7 min-w-[80px] rounded-tr-lg rounded-br-lg">
                                            {/* <!-- <span class="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Status
                                    <a href="#" class="pl-[5px]">
                                        <img src="images/sort.svg" alt="icon" />
                                    </a>
                                </span> --> */}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categoryList.length > 0 && categoryList.map((category, index) => (
                                        <>
                                            <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                    {category.name}
                                                </td>
                                                <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                    {category.description}
                                                </td>
                                                <td className="text-xs3 font-normal text-[#0D1B2A] px-5 py-3 dropstart relative flex justify-center">
                                                    <button
                                                        href="#"
                                                        className="flex justify-center items-center"
                                                        dropdown-toggle
                                                        id={`actionButton${index}`}
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                        onClick={() => { if (index === editAction) setEditAction(''); else setEditAction(index); }}
                                                    >
                                                        <img src="/images/three-dots.html.png" alt="icon" />
                                                    </button>
                                                    <ul className={`dropdown-menu ${editAction === index ? 'show' : 'hidden'} z-20 bg-[#FFFFFF] rounded-lg shadow-s11 left-[-24px] p-3 min-w-max absolute shadow-s2 z-[50] w-fit`} aria-labelledby={`actionButton${index}`}>
                                                        <button href="" className="inline-block dropdown-item" data-bs-toggle="modal" data-bs-target="#update-category">
                                                            <li className="text-sm font-normal text-[#000000] py-1 px-2 cursor-pointer" onClick={() => handleUpdate(category)}>
                                                                Update
                                                            </li>
                                                        </button>
                                                    </ul>
                                                </td>
                                            </tr>
                                            <tr className="h-1" />
                                        </>

                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) }
                    { categoryList.length > 0 && (
                        <Pagination
                            handlePageClick={handlePageClick}
                            List={alldata}
                            currentPage={currentPage}
                            totalPage={totalPage}
                        />
                    )}
                    {addCategoryPopup && (
                        <AddCategoryModal
                            addCategoryPopup={addCategoryPopup}
                            setAddcategoryPopup={setAddcategoryPopup}
                            createResoureCategory={createResoureCategory}
                            addCategoryDetails={addCategoryDetails}
                            setaddCategoryDetails={setaddCategoryDetails}
                            submitSelected={submitSelected}
                            setsubmitSelected={setsubmitSelected}
                            threeDotLoader={threeDotLoader}
                            setThreeDotsLoader={setThreeDotsLoader}
                            isEdit={isEdit}
                            setIsEdit={setIsEdit}
                            selected={selected}
                            setSelected={setSelected}
                            handleClose={handleClose}
                        />
                    )}
                </div>
            )}
            {emptyData && <EmptyScreen search={searchValue} text="no Categories" buttonRequired={false} />}
        </div>
    );
}

export default CategoryManagement;
